import React, { useState, useEffect, FC, ImgHTMLAttributes } from "react";

type Props = {
	urls: string[];
	alt?: string;
	className?: string;
	onLoad?: () => void;
} & Partial<ImgHTMLAttributes<HTMLImageElement>>;

export const ImageWithFallbacks: FC<Props> = ({ urls, alt, ...rest }) => {
	const [currentUrls, setCurrentUrls] = useState([...new Set(urls)]);

	useEffect(() => {
		setCurrentUrls([...new Set(urls)]);
	}, [urls.join(",")]);

	const loadNext = () => {
		if (currentUrls.length < 1) {
			return;
		}
		setCurrentUrls((prevUrls) => prevUrls.slice(1));
	};

	return <img src={currentUrls[0]} onError={loadNext} alt={alt} {...rest} />;
};
